// Google OAuth Configuration
export const authConfig = {
  // You need to replace this with your actual Google OAuth Client ID
  googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID || '262665686673-qet6u3710uu7d6p7qv6qi8rsgtgb2ait.apps.googleusercontent.com',
  
  // Allowed email domains
  allowedDomains: ['maksimer.com', 'maksimer.no'],
  
  // OAuth scopes
  scopes: [
    'openid',
    'email',
    'profile'
  ]
};

// Validation function for email domains
export const isValidEmailDomain = (email: string): boolean => {
  const domain = email.split('@')[1];
  return authConfig.allowedDomains.includes(domain);
};

